document.addEventListener("DOMContentLoaded", function () {
  const pickupSwiper = document.querySelector(".pickup-swiper");

  if (!pickupSwiper) return;

  const swiper = new Swiper(".pickup-swiper", {
    slidesPerView: window.innerWidth <= 768 ? 1 : 2,
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      769: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      }
    }
  });

  pickupSwiper.addEventListener('click', function (e) {
    const target = e.target.closest('.swiper-button-disabled, a[href="#"]');
    if (target) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
});